/**
 * 손으로 그리는 차트 툴팁(`tooltip.custom`)의 **한 벌** — 날짜 머리 + 계열마다 점·이름·값.
 *
 * 🔑 색은 CSS 변수(테마 글자 토큰)로 적는다 — 다크 모드에서도 읽힌다. 계열 색은 «점»에만 쓴다(글자는 쓰지 않는다).
 * ⚠️ 상류는 `custom` 의 반환을 문자열로 다룬다 — 그릴 것이 없으면 빈 문자열을 돌려준다.
 */

export type ChartTooltipItem = {
  name: string;
  /** 이미 포맷한 값 */
  value: string;
  color: string;
};

/** @returns 툴팁 HTML · 항목이 없으면 `''` */
export function chartTooltipHtml(header: string, items: ChartTooltipItem[]): string {
  if (!items.length) return '';
  const rows = items
    .map(
      (item) =>
        `<div style="display:flex;justify-content:space-between;align-items:center;gap:16px;margin:2px 0;">` +
        `<div style="display:flex;align-items:center;gap:8px;">` +
        `<span style="width:8px;height:8px;border-radius:50%;background:${item.color};display:inline-block;"></span>` +
        `<span style="font-size:12px;color:var(--palette-text-secondary);">${item.name}</span>` +
        `</div>` +
        `<span style="font-size:12px;font-weight:600;color:var(--palette-text-primary);">${item.value}</span>` +
        `</div>`,
    )
    .join('');
  return (
    `<div style="padding:8px 12px;min-width:160px;">` +
    `<div style="font-size:12px;font-weight:600;color:var(--palette-text-secondary);margin-bottom:4px;">${header}</div>` +
    rows +
    `</div>`
  );
}
